import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Box, Text } from "@theme-ui/components"

const Image = ({ image }) => {
  return (
    <Box mb={5}>
      <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
        <GatsbyImage image={image.gatsbyImageData} alt="" />
      </Box>
      {image.title && (
        <Box>
          <Text dir="invalid" variant="caption">{image.title}</Text>
        </Box>
      )}
    </Box>
  )
}

export default Image
